"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateSingleToMultiplePredicates = void 0;
function updateSingleToMultiplePredicates(rule) {
    var _a;
    if ('Predicate' in rule && rule.Predicate) {
        rule.Predicates = [rule.Predicate, ...((_a = rule.Predicates) !== null && _a !== void 0 ? _a : [])];
        delete rule.Predicate;
    }
    return rule;
}
exports.updateSingleToMultiplePredicates = updateSingleToMultiplePredicates;
